export default {
  Initial: 'initial',
  Loading: 'loading',
  Complete: 'complete',
  Error: 'error'
}
